export class SIQReplyViewTheme {
  backgroundColor = "null";
  titleColor = "null";
  subtitleColor = "null";
  verticalLine = "null";
  messageTypeIconColor = "null";
  closeButton = "null";
}
//# sourceMappingURL=SIQReplyViewTheme.js.map